import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  ApiDependencyProviderService,
  CreateResourceResponse,
} from '@web/common';
import { PublicIssueCreateRequest } from '../requests/public-issue-create.request';

@Injectable({
  providedIn: 'root',
})
export class PublicIssueApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public createIssue(
    request: PublicIssueCreateRequest,
  ): Observable<CreateResourceResponse> {
    const path = `issue`;
    const url = this.provider.httpUrlFactory.simple(this.hostUrl(), path);
    const context = this.provider.httpContextBuilder
      .skipByAuthTokenInterceptor()
      .skipByLoadingInterceptor()
      .skipByHttpErrorInterceptor()
      .build();
    const body = this.provider.httpHelper.requestToBody(
      request,
      PublicIssueCreateRequest,
    );

    return this.provider.http
      .post(url, body, { context })
      .pipe(
        map(this.provider.httpHelper.bodyToResponse(CreateResourceResponse)),
      );
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
